export default __webpack_public_path__ + "static/media/project6.85798305.png";